export default {
  url: 'https://bm9zady6qe.execute-api.eu-west-1.amazonaws.com', /* type http://crm-api.id-a.pl if you want to use demo API */
  path: {
    prefix: 'dev',
    storage: 'storage',
    upload: 'files/file-upload',
  },
}
